var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"align-self-center card bg-light",style:(_vm.frame)},[_c('Header',{ref:"header"}),_c('main',{staticClass:"page-view bg-light"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }